import { FormErrors } from '@core/form';

import { CreateShopDto, CreateShopDtoPersistence } from '../dtos';
import { IShopName } from '../interfaces';

export class CreateShopMapper {
  public static toDomain(shop: IShopName): CreateShopDto {
    return {
      id: shop.id.toString(),
      name: shop.name,
      countryId: shop.countryId,
    };
  }

  public static toPersistence(shop: CreateShopDto): CreateShopDtoPersistence {
    return {
      name: shop.name,
      country_id: shop.countryId,
      shop_name_id: shop.id,
    };
  }
}

export class CreateShopErrorsMapper {
  public static toDomain(errors): FormErrors<CreateShopDto> {
    return {
      id: errors.id?.join('. '),
      name: errors.name?.join('. '),
    };
  }
}
